import { t } from "../services/utils";
import React from "react";
import { connect } from "react-redux";
import red from "@material-ui/core/colors/red";
import { useNavigate } from "react-router";
import {
  DELETE_ACCESS_TOKEN,
  REGISTER_DID_OPEN_MAIN_MENU,
  REGISTER_CLIENTS_VIEW_EXIT_FOCUS_ID,
} from "../constants/action-types";
import NotificationsView from "../scenes/notifications/NotificationsView";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import Badge from "@material-ui/core/Badge";
import MenuItem from "@material-ui/core/MenuItem";
import NotificationsIcon from "@material-ui/icons/Notifications";
import { Language } from "@material-ui/icons";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import Button from "@material-ui/core/Button";
import Popover from "@material-ui/core/Popover";
import Divider from "@material-ui/core/Divider";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { withStyles } from "@material-ui/core/styles";
import IconMoon from "./IconMoon";
import {
  primary,
  primaryDark,
  primaryDark40,
  primary5,
} from "../constants/colors";
import i18n from "../i18n";
const menuItems = [
  {
    label: t("workoutTemplates"),
    value: 2,
    iconName: "Workout",
    type: "menuItem",
  },
  {
    label: t("planTemplates"),
    value: 3,
    iconName: "Plan-1",
    type: "menuItem",
  },
  {
    label: t("exercises"),
    value: 4,
    iconName: "Exercise",
    type: "menuItem",
  },
  {
    label: t("habits"),
    value: 13,
    iconName: "habitscheckin",
    type: "menuItem",
  },
  {
    label: t("leaderboard"),
    value: 8,
    iconName: "Leaderboard",
    type: "menuItem",
  },
  {
    type: "divider",
  },
  {
    label: t("packagesAndPayments"),
    value: 9,
    iconName: "Subscription",
    type: "menuItem",
    isAdmin: true,
  },
  {
    label: t("referralMarketing"),
    value: 15,
    iconName: "affiliate",
    type: "menuItem",
    isAdmin: true,
  },
  {
    type: "divider",
  },
  {
    label: t("scheduledMessages"),
    value: 6,
    iconName: "schedulemessage",
    type: "menuItem",
  },
  {
    label: t("autoResponders"),
    value: 12,
    iconName: "schedulemessage",
    type: "menuItem",
  },
  {
    type: "divider",
  },
  {
    label: t("filesLinks"),
    value: 14,
    iconName: "link",
    type: "menuItem",
    isAdmin: true,
  },
  {
    label: t("trainers"),
    value: 7,
    iconName: "User",
    type: "menuItem",
    isAdmin: true,
  },
  {
    label: t("settings"),
    value: 11,
    iconName: "Settings",
    type: "menuItem",
  },
];

const languages = [
  {
    label: "English",
    value: "en",
  },
  {
    label: "French",
    value: "fr",
  },
  {
    label: "Spanish",
    value: "es",
  },
];

const styles = {
  root: {
    color: primaryDark,
    "&:hover": {
      backgroundColor: primary5,
      color: primary,
    },
    "&:hover $icon": {
      color: primary,
    },
  },
  icon: {
    color: primaryDark40,
  },
  moreButton: {
    color: primaryDark,
  },
  anchorOriginTopRightRectangle: {
    minWidth: 25,
    borderRadius: "50%",
    padding: 5,
  },
};
class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      notificationViewOpen: false,
      anchorEl: null,
      anchorElPopover: null,
      anchorElLanguage: null,
    };
  }
  handleTabChange = (event, value) => {
    console.log("value is", value);
    switch (value) {
      case "News": {
        this.props.loadStoriesView(this.props.navigate);
        break;
      }
      case "Clients": {
        this.props.registerExitFocusId(null);
        this.props.loadClientsView(this.props.navigate);
        break;
      }
      case "Groups": {
        this.props.loadGroupsView(this.props.navigate);
        break;
      }
    }
    this.setState({
      value,
    });
  };
  componentDidMount = () => {};
  onMenuItemClicked = (e, item) => {
    const { value } = e.target;
    event.stopPropagation();
    this.setState({
      anchorEl: null,
    });
    switch (value) {
      case 1: {
        this.props.loadClientsView(this.props.navigate);
        break;
      }
      case 2: {
        this.props.loadWorkoutTemplates(this.props.navigate);
        break;
      }
      case 3: {
        this.props.loadPlanTemplates(this.props.navigate);
        break;
      }
      case 4: {
        this.props.loadExercises(this.props.navigate);
        break;
      }
      case 5: {
        this.props.logout();
        break;
      }
      case 6: {
        this.props.loadScheduledMessages(this.props.navigate);
        break;
      }
      case 7: {
        this.props.loadTrainersView(this.props.navigate);
        break;
      }
      case 8: {
        this.props.loadLeaderBoardView(this.props.navigate);
        break;
      }
      case 9: {
        this.props.loadSignupForms(this.props.navigate);
        break;
      }
      case 11: {
        this.props.loadSettings(this.props.navigate);
        break;
      }
      case 12: {
        this.props.loadAutoResponders(this.props.navigate);
        break;
      }
      case 13: {
        this.props.loadHabits(this.props.navigate);
        break;
      }
      case 14: {
        this.props.loadFilesAndLinks(this.props.navigate);
        break;
      }
      case 15: {
        this.props.loadReferrals(this.props.navigate);
        break;
      }
    }
  };
  handleClick = (event) => {
    event.stopPropagation();
    this.setState({
      anchorEl: event.currentTarget,
    });
  };
  handleClose = (event) => {
    event.stopPropagation();
    this.setState({
      anchorEl: null,
    });
  };
  onClientsClicked = () => {
    this.props.registerExitFocusId(null);
    this.props.loadClientsView(this.props.navigate);
  };
  onNewsClicked = () => {
    this.props.loadStoriesView(this.props.navigate);
  };
  onNotificationsClicked = (event) => {
    event.preventDefault();
    this.setState({
      anchorElPopover: event.currentTarget,
    });
  };
  handleRequestNotificationViewClose = () => {
    this.setState({
      anchorElPopover: null,
    });
  };
  onNotificationClicked = (notification) => {
    this.setState({
      notificationViewOpen: false,
      anchorElPopover: null,
    });
  };
  onClickLearn = () => {
    let win = window.open("https://help.trainerfu.com/", "_blank");
    win.focus();
  };
  onBrandedAppClick = () => {
    let win = window.open(
      "https://www.trainerfu.com/white-label-fitness-app.html",
      "_blank",
    );
    win.focus();
  };
  handleChangeLanguage = (event) => {
    this.setState({
      anchorElLanguage: event.currentTarget,
    });
  };
  handleLanguageClose = () => {
    this.setState({
      anchorElLanguage: null,
    });
  };
  changeLanguage = (lng) => {
    i18n.changeLanguage(lng, () => {
      localStorage.setItem("language", lng);
      console.log("Language changed to", lng);
      // this.props.changeLanguage(lng);
      setTimeout(() => {
        window.location.reload();
      }, 0);
    });
  };
  render = () => {
    const { anchorEl, anchorElPopover, anchorElLanguage } = this.state;
    const open = Boolean(anchorEl);
    const openPopover = Boolean(anchorElPopover);
    const openLanguage = Boolean(anchorElLanguage);
    const { appTitle, classes } = this.props;
    let selectedTab = "";
    if (
      appTitle === "News" ||
      appTitle === "Clients" ||
      appTitle === "Groups"
    ) {
      selectedTab = appTitle;
    }
    const styles = {
      appBar: {
        position: "fixed",
        top: 0,
        overflow: "hidden",
        maxHeight: 60,
        backgroundColor: "white",
        boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.1)",
      },
      menuButton: {
        marginLeft: 0,
      },
      toolBar: {
        paddingLeft: 40,
        paddingRight: 40,
      },
      menuAlert: {
        width: 10,
        height: 10,
        borderRadius: 5,
        backgroundColor: red[600],
        position: "fixed",
        top: 18,
        left: 12,
        zIndex: 100000,
      },
      menuItem: {
        paddingTop: 10,
        paddingBottom: 10,
      },
      appTitle: {
        fontSize: 24,
        fontWeight: "bold",
        color: "rgba(0, 0, 0, 0.87)",
        width: "50%",
      },
      tab: {
        minWidth: 60,
        minHeight: 58,
        padding: "6px 24px",
        textTransform: "capitalize",
        fontSize: 16,
        color: primaryDark,
      },
      badge: {
        marginTop: -6,
        marginRight: -8,
        padding: 4,
      },
      title: {
        fontFamily: "'Inter', sans-serif",
        fontWeight: "bold",
        fontSize: 22,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "block",
      },
      labelContainer: {
        paddingLeft: 0,
        paddingRight: 0,
      },
      indicator: {
        height: 5,
      },
      badge: {
        minWidth: 25,
        borderRadius: "50%",
        padding: 5,
      },
    };
    let nnc = this.props.newNotificationsCount;
    return (
      <div>
        <AppBar style={styles.appBar} elevation={1}>
          <Toolbar style={styles.toolBar}>
            <Typography variant="h6" style={styles.appTitle}>
              <span style={styles.title}>{this.props.appTitle}</span>
            </Typography>
            {/* <button onClick={() => this.changeLanguage("en")}>english</button>
            <button onClick={() => this.changeLanguage("fr")}>french</button>
            <button onClick={() => this.changeLanguage("es")}>Spanish</button> */}
            <div
              style={{
                flexGrow: 1,
              }}
            />
            <Tabs
              value={!!selectedTab && selectedTab}
              indicatorColor="primary"
              textColor="primary"
              TabIndicatorProps={{
                style: {
                  height: "5px",
                  borderRadius: "3px",
                },
              }}
              onChange={this.handleTabChange}
              style={{
                minHeight: 60,
              }}
            >
              <Tab value="Clients" style={styles.tab} label={t("clients")} />
              <Tab
                value="News"
                style={styles.tab}
                label={
                  <Badge
                    badgeContent={this.props.hasNewStories ? "1+" : " "}
                    color={this.props.hasNewStories ? "secondary" : "default"}
                    className="badge-style"
                  >
                    {t("news")}
                  </Badge>
                }
              />
              <Tab value="Groups" style={styles.tab} label={t("groups")} />
            </Tabs>
            <Button
              style={{
                fontSize: 16,
              }}
              color="default"
              variant="text"
              onClick={this.handleClick}
              className={classes.moreButton}
            >
              {t("more")}
              {open ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
            </Button>
            <Popover
              id={open ? "simple-popper" : undefined}
              open={open}
              anchorEl={anchorEl}
              anchorOrigin={{
                horizontal: "right",
                vertical: "bottom",
              }}
              transformOrigin={{
                horizontal: "right",
                vertical: "top",
              }}
              onClose={this.handleClose}
              PaperProps={{
                style: {
                  marginTop: 5,
                },
              }}
              style={{
                padding: 15,
              }}
            >
              {menuItems.map((item) =>
                item.type === "menuItem" ? (
                  item.isAdmin ? (
                    this.props.me.is_admin && (
                      <MenuItem
                        key={item.value}
                        value={item.value}
                        onClick={this.onMenuItemClicked}
                        style={styles.menuItem}
                        className={classes.root}
                      >
                        <IconMoon
                          icon={item.iconName}
                          style={{
                            marginRight: 10,
                          }}
                          className={classes.icon}
                        />
                        {item.label}
                      </MenuItem>
                    )
                  ) : (
                    <MenuItem
                      key={item.value}
                      value={item.value}
                      onClick={this.onMenuItemClicked}
                      style={styles.menuItem}
                      className={classes.root}
                    >
                      <IconMoon
                        icon={item.iconName}
                        style={{
                          marginRight: 10,
                        }}
                        className={classes.icon}
                      />
                      {item.label}
                    </MenuItem>
                  )
                ) : (
                  <Divider key={item.value} />
                ),
              )}
              <MenuItem
                key={5}
                value={5}
                onClick={this.onMenuItemClicked}
                style={styles.menuItem}
                className={classes.root}
              >
                <IconMoon
                  icon="Logout"
                  style={{
                    marginRight: 10,
                  }}
                  className={classes.icon}
                />
                {t("logout")}
              </MenuItem>
              <div
                style={{
                  margin: "4px 16px 20px 16px",
                }}
              >
                <Button
                  color="primary"
                  variant="contained"
                  onClick={this.onBrandedAppClick}
                  fullWidth
                  startIcon={<IconMoon color="white" icon="Launch" />}
                >
                  {t("getYourBrandedApp")}
                </Button>
              </div>
            </Popover>
            <IconButton color="default" onClick={this.onNotificationsClicked}>
              <Badge
                badgeContent={nnc > 0 ? (nnc > 9 ? "9+" : nnc) : ""}
                color={
                  this.props.newNotificationsCount > 0 ? "secondary" : "default"
                }
              >
                <IconMoon icon="Notification" size={24} color={primaryDark40} />
              </Badge>
            </IconButton>

            <Button
              variant="outlined"
              color="primary"
              onClick={this.onClickLearn}
              style={{
                marginLeft: 10,
              }}
              startIcon={<IconMoon color={primary} icon="help" />}
            >
              {t("learn")}
            </Button>
            <Popover
              open={openPopover}
              anchorEl={anchorElPopover}
              anchorOrigin={{
                horizontal: "right",
                vertical: "bottom",
              }}
              transformOrigin={{
                horizontal: "right",
                vertical: "top",
              }}
              onClose={this.handleRequestNotificationViewClose}
              PaperProps={{
                elevation: 0,
                style: {
                  boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
                  borderRadius: 6,
                },
              }}
            >
              <NotificationsView
                onNotificationClicked={this.onNotificationClicked}
              />
            </Popover>
          </Toolbar>
        </AppBar>
      </div>
    );
  };
}

// Create a wrapper component that uses the useNavigate hook
const HeaderWithRouter = (props) => {
  const navigate = useNavigate();
  return <Header {...props} navigate={navigate} />;
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadClientsView: (navigate) => {
      navigate("/clients");
    },
    loadStoriesView: (navigate) => {
      console.log("loading stories");
      navigate("/stories");
    },
    loadGroupsView: (navigate) => {
      navigate("/groups");
    },
    loadTrainersView: (navigate) => {
      navigate("/trainers");
    },
    loadExercises: (navigate) => {
      navigate("/exercises");
    },
    loadWorkoutTemplates: (navigate) => {
      navigate("/workout-templates");
    },
    loadLeaderBoardView: (navigate) => {
      navigate("/leaderBoard");
    },
    loadPlanTemplates: (navigate) => {
      navigate("/plan-templates");
    },
    loadSignupForms: (navigate) => {
      navigate("/forms");
    },
    loadAutoResponders: (navigate) => {
      navigate("/auto-responders");
    },
    loadHabits: (navigate) => {
      navigate("/habits");
    },
    logout: () => {
      dispatch({
        type: DELETE_ACCESS_TOKEN.REQUEST,
      });
    },
    registerDidOpenMainMenu: () => {
      dispatch({
        type: REGISTER_DID_OPEN_MAIN_MENU,
      });
    },
    loadSettings: (navigate) => {
      navigate("/settings");
    },
    loadScheduledMessages: (navigate) => {
      navigate(`/auto-messaging/0`);
    },
    loadFilesAndLinks: (navigate) => {
      navigate("/settings/app-links");
    },
    loadReferrals: (navigate) => {
      navigate("/referrals");
    },
    registerExitFocusId: (id) => {
      dispatch({
        type: REGISTER_CLIENTS_VIEW_EXIT_FOCUS_ID,
        payload: {
          id: id,
        },
      });
    },
    changeLanguage: (lng) => {
      dispatch({
        type: "UPDATE_ME",
        payload: {
          language: lng,
        },
      });
    },
  };
};

const mapStateToProps = (state) => {
  return {
    router: state.router,
    me: state.me,
    hasNewStories: state.hasNewStories,
    newNotificationsCount: state.newNotificationsCount,
  };
};

export default withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(HeaderWithRouter),
);
